import ym from "react-yandex-metrika";

type Args = { target: string; params?: unknown };

export class MetrikaService {
  send(args: Args) {
    ym("reachGoal", args.target, args.params);
  }
}
